<template>
  <!-- 加入群组 -->
  <div aria-labelledby="myModalLabel" class="modal fade" id="addgroup" role="dialog" tabindex="-1">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button aria-label="Close" class="close" data-dismiss="modal" type="button">
            <span aria-hidden="true">×</span>
          </button>
          <h4 class="modal-title" id="myModalLabel">加入群组</h4>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <div class="input-group">
              <div class="input-group-btn">
                <button
                  aria-expanded="false"
                  aria-haspopup="true"
                  class="btn btn-link dropdown-toggle"
                  data-toggle="dropdown"
                  type="button"
                >
                  {{showCategoryName}}
                  <span class="caret"></span>
                </button>
                <ul class="dropdown-menu">
                  <li @click="allCategory">
                    <a>全部类型</a>
                  </li>
                  <li
                    v-for="cate in categorys"
                    :key="cate.group_category_number"
                    @click="changeCategory(cate)"
                  >
                    <a>{{cate.group_category_name}}</a>
                  </li>
                </ul>
              </div>
              <input
                class="form-control"
                placeholder="搜索所有组"
                type="text"
                v-model="query.search_name"
              />
              <div class="input-group-btn">
                <button class="btn btn-primary" type="button" @click="groupSearch">
                  <i class="ti-search"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="group-list-wrap clearfix">
              <p v-show="!query.search_name">请输入搜索内容</p>
              <p v-show="query.search_name && !groups.length">{{processing}}</p>
              <div class="group-list" v-for="group in groups" :key="group.group_number">
                <div class="checkbox i-checks">
                  <input
                    type="checkbox"
                    :value="group.group_number"
                    @change="selectGroup"
                    v-model="selectedGroup"
                    name="group"
                    data-vv-as="群组 "
                    v-validate="{ required: true }"
                  />
                  <i></i>
                </div>
                <div class="head">
                  <img :src="group.group_logo" />
                </div>
                <div class="name">{{group.group_name}}</div>
                <div class="style">{{group.group_category_name}}</div>
                <div class="info">{{group.group_description}}</div>
              </div>
            </div>
            <span class="help-block" v-show="errors.has('group')">{{ errors.first('group') }}</span>
          </div>
          <div class="form-group" v-show="groups.length">
            <textarea
              class="form-control"
              style="resize: vertical;"
              rows="3"
              placeholder="请填写入群原因..."
              v-model.trim="message"
              name="message"
              data-vv-as="入群原因 "
              v-validate="{ required:true, min:1,max:255 }"
            ></textarea>
            <span class="help-block" v-show="errors.has('message')">{{ errors.first('message') }}</span>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-default" type="button" @click="cancleApply">取消</button>
          <button class="btn btn-primary" type="button" @click="groupApply">加入</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import debounce from "lodash.debounce";
import { getGroupCategorys, publicGroups, groupApply } from "@/api/group/group";
export default {
  name: "GroupAdd",
  data() {
    return {
      processing: "未搜索到相关内容",
      query: {
        search_name: "",
        category: ""
      },
      categorys: [],
      groups: [],
      selectedGroup: [],
      message: "",
      showCategoryName: "全部类型"
    };
  },
  created() {
    this.debouncedSearch = debounce(this.groupSearch, 500);
  },
  watch: {
    "query.search_name": {
      handler: function(newValue) {
        this.processing = "正在搜索……";
        if (newValue.trim()) {
          this.debouncedSearch();
        } else {
          this.groups = [];
        }
      }
    }
  },
  methods: {
    selectGroup() {
      if (this.selectedGroup.length > 1) {
        this.selectedGroup.shift();
      }
    },
    allCategory() {
      this.showCategoryName = "全部类型";
      this.query.category = "";
      this.groupSearch();
    },
    changeCategory(category) {
      this.query.category = category.group_category_number;
      this.showCategoryName = category.group_category_name;
      this.groupSearch();
    },
    getGroupCategorys() {
      getGroupCategorys()
        .then(res => {
          this.categorys = res.entity;
        })
        .catch();
    },
    groupSearch() {
      if (this.query.search_name.trim() === "") {
        return false;
      }
      publicGroups(this.query)
        .then(res => {
          if (res.status_code === 200) {
            this.processing = "未搜索到相关内容";
            this.groups = res.entity.datas;
          } else {
            this.$message({
              type: "error",
              message: res.message
            });
          }
        })
        .catch(err => {
          this.$message({
            type: "error",
            message: err
          });
        });
    },
    cancleApply() {
      $("#addgroup").modal("hide");
      this.showCategoryName = "全部类型";
      this.groups = [];
      this.query.search_name = "";
      this.query.category = "";
      this.selectedGroup = [];
      this.message = "";
      this.$validator.reset();
    },
    groupApply() {
      this.$validator.validate().then(valid => {
        if (valid) {
          let params = {
            group_number: this.selectedGroup[0],
            message: this.message
          };
          groupApply(params)
            .then(res => {
              if (res.status_code === 200) {
                $("#addgroup").modal("hide");
                this.$message({
                  type: "success",
                  message: res.message
                });
                this.selectedGroup = [];
                this.message = "";
                this.$nextTick(() => {
                  this.$validator.reset();
                });
              } else {
                this.$message({
                  type: "error",
                  message: res.message
                });
              }
            })
            .catch(err => {
              this.$message({
                type: "error",
                message: err
              });
            });
        }
      });
    }
  },
  mounted() {
    let that = this;
    $("#addgroup").on("show.bs.modal", function(e) {
      that.getGroupCategorys();
    });
  },
  destroyed() {
    $("#addgroup").off();
  }
};
</script>

<style scoped>
@media (max-width: 768px) {
  .modal-lg {
    width: auto;
  }
}
</style>